export default __webpack_public_path__ + "static/media/whatsapp_banner_headline_mobile.b4f30099.gif";